import SystemConfig, { CONFIG_PARAMS } from "../system/SystemConfig";
import IDOM from "./IDOM";
import SystemPlatform from "../system/SystemPlatform";
import IUIActions from "./IUIActions";
import { isIOS } from "../device/device";
import { injectable } from "inversify";
import AbstractUIScreen from "./screen/AbstractUIScreen";
import AudioController from "./AudioController";
import { isLocalhost } from "../helpers";

@injectable()
export default abstract class AbstractUI {
	protected config: SystemConfig;
	protected gameset: any;
	protected platform: SystemPlatform;
	protected dom: IDOM;
	protected uiActions: IUIActions;
	protected audioController: AudioController;

	public screen: AbstractUIScreen;
	public audioCtx: AudioContext;

	protected loaded: boolean = false;

	protected constructor(
		config: SystemConfig,
		dom: IDOM,
		uiActions: IUIActions,
		uiScreen: AbstractUIScreen,
		audioController: AudioController
	) {
		this.config = config;
		this.gameset = config.gameset;
		this.platform = config.platform;
		this.dom = dom;
		this.uiActions = uiActions;
		this.audioController = audioController;

		this.screen = uiScreen;
	}
	private getConfigUrl() {
		if (isLocalhost()) {
			return "https://games.kajotgames.dev/config/game_backgrounds";
		}
		return "/config/game_backgrounds";
	}
	create() {
		this.screen.init();
		this.dom.createDOM();
		document.title = this.config.gameset.gameName || document.title;

		isIOS() && document.getElementById("wrapper").classList.add("device-ios");
		if (this.config.get(CONFIG_PARAMS.BG_IMG)?.toLowerCase() === "true") {
			$(".mx-wrapper, body").css({
				background: `url(${this.getConfigUrl()}/${this.config.get(
					CONFIG_PARAMS.GAME_ID
				)}.jpg)`,
				backgroundSize: "cover",
			});
			$(".mx-wrapper .mx-container").css({
				boxShadow: "0px 0px 20px 15px rgba(0,0,0,0.75)",
				padding: "0 10px",
			});
		} else if (this.config.get(CONFIG_PARAMS.BG_COLOR) !== "transparent") {
			if (this.config.get(CONFIG_PARAMS.BG_COLOR)) {
				$(".mx-wrapper, body").css({
					"background-color": `#${this.config.get(CONFIG_PARAMS.BG_COLOR)}`,
				});
			} else {
				$(".mx-wrapper, body").css({ "background-color": `#000` });
			}
		}
		// console.log(window);
		// @ts-ignore
		const audioCtx = (this.audioCtx = new (window.AudioContext ||
			window.webkitAudioContext)());
		// console.log(audioCtx);
		this.unlockAudioContext(audioCtx);

		if (isIOS()) {
			audioCtx.onstatechange = () => {
				if (
					audioCtx.state === "interrupted" ||
					audioCtx.state === "suspended"
				) {
					document.removeEventListener("touchstart", this);
					document.addEventListener("touchstart", this, false);
				}
			};
		}
	}

	async handleEvent(event) {
		switch (event.type) {
			case "touchstart":
				try {
					await this.audioCtx.resume();
				} catch (e) {}
				document.removeEventListener(event.type, this);
				break;
			default:
				break;
		}
	}

	init() {
		this.dom.init();
		this.uiActions.init();
	}

	unlockAudioContext(audioCtx) {
		if (audioCtx.state !== "suspended" || audioCtx.state !== "interrupted")
			return;
		const b = document.body;
		const events = ["touchstart", "touchend", "mousedown", "keydown"];
		events.forEach((e) => b.addEventListener(e, unlock, false));
		function unlock() {
			audioCtx.resume().then(clean);
		}
		function clean() {
			events.forEach((e) => b.removeEventListener(e, unlock));
		}
	}
}

export function repaint(jQElement) {
	jQElement.css("display", "none");
	jQElement.each((i, v) => {
		v.offsetHeight;
	});
	jQElement.css("display", "block");
}
